import type { ConfigContract } from "../types";

export default {
  TAMEENI_HOME: "https://qcmotor.gettameeni.com",
  API_BASE_URL: "https://travel-dev.gettameeni.com/backend/api/v1/",
  CONNECTION_API_URL:
    "https://travel-dev.gettameeni.com/backend/QuoteNotifierHub",
  AMEEN_URL: "https://qcmotor.gettameeni.com/ameen",
  IDENTITY_URL: "https://idp.gettameeni.com/",
  IDENTITY_CLIENT_ID: "TravelWebApp",
  IDENTITY_CLIENT_SECRET: "rasan@123",
  IDENTITY_REDIRECT_URL: "http://localhost:3000",
  APP_URL: "http://localhost:3000",
  OTP_TIMER: 3,
  SESSION_MAX_AGE: 8 * 60 * 60,
  IS_LOGIN_ENFORCE: true,
  FILTER_MIN_QUOTATIONS: 4,
} satisfies ConfigContract;
